import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ISetExtractTaskPublishedConnectionAttributesParams {
  id: string;
  level: string;
  startingItems: string[];
  type: string; // ExtractTaskType
}

export class SetExtractTaskPublishedConnectionAttributesRequest extends Request<ISetExtractTaskPublishedConnectionAttributesParams, IResult> {
  constructor(params: ISetExtractTaskPublishedConnectionAttributesParams) {
    super('setExtractTaskPconnAttributes', params);
  }
}
